export default __webpack_public_path__ + "static/2022-4c40affc2908f5fe4d70239695373bcd.pdf";